import React from 'react';

// pieces
import { Box } from '@thepuzzlers/pieces';

export const LottieContainer = ({ containerRef, lottieRef, lottie, sx }) => {
  const [Lottie, setLottie] = React.useState(null);

  React.useEffect(() => {
    let mounted = true;
    import('lottie-react').then((mod) => {
      if (mounted) setLottie(() => mod.default);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Box ref={containerRef} sx={sx}>
      {Lottie ? (
        <Lottie
          lottieRef={lottieRef}
          height="100%"
          animationData={lottie}
          loop={false}
          autoplay={false}
        />
      ) : (
        // harmless shell during SSR / before hydration
        <div style={{ height: '100%', width: '100%' }} aria-hidden="true" />
      )}
    </Box>
  );
};
